import { FC, useState } from "react";
import { classes, stylesheet } from "typestyle";
import { Flex } from "../../../elements/flex.element";
import { Button } from "../../../elements/button.element";

type Props = {
  values: string[];
  onConfirm: (keptValues: string[] | null) => void;
};

const ValueIdentificationTrimView: FC<Props> = ({ values, onConfirm }) => {
  const [keptValues, setKeptValues] = useState<string[]>([]);
  const requiredNumberOfValues = values.length > 10 ? 10 : 5;

  return (
    <Flex direction="column" alignItems="stretch" flex={1}>
      <Flex direction="column" flex={0}>
        {values.length > 10 && (
          <p className={styles.info}>
            Okay, keep going. Pick only the Values that feel most important to
            you right now. Our goal is to have 10 Values to work with.
          </p>
        )}
        {values.length <= 10 && (
          <p className={styles.info}>
            Pick your top 5 Values that feel most important to you right now.
          </p>
        )}
      </Flex>

      <Flex
        direction="column"
        justifyContent="flex-start"
        flex={1}
        style={{ gap: 15, flexWrap: "wrap", padding: 20 }}
      >
        {values.map((value, index) => (
          <Flex
            key={value + index}
            attributes={{
              onClick: () => {
                if (keptValues.includes(value)) {
                  setKeptValues(
                    keptValues.filter(
                      (selectedValue) => selectedValue !== value,
                    ),
                  );
                } else if (keptValues.length < requiredNumberOfValues) {
                  setKeptValues(keptValues.concat(value));
                }
              },
              className: classes(
                styles.card,
                keptValues.includes(value) && styles.selectedCard,
              ),
            }}
          >
            {value}
          </Flex>
        ))}
      </Flex>

      <Flex direction="row" justifyContent="center" flex={0}>
        <Button
          hideSpinnerOnSubmit
          centerChildren
          attributes={{
            disabled: keptValues.length < requiredNumberOfValues,
            onClick: () => onConfirm(keptValues),
          }}
        >
          {keptValues.length === requiredNumberOfValues && "Confirm Selection"}
          {keptValues.length < requiredNumberOfValues &&
            `Select ${requiredNumberOfValues - keptValues.length} More`}
        </Button>
      </Flex>
    </Flex>
  );
};

export { ValueIdentificationTrimView };

const styles = stylesheet({
  info: {
    fontSize: ".9em",
    color: "rgb(var(--rgb-color-text-tertiary))",
    textAlign: "center",
    margin: 0,
  },

  card: {
    borderRadius: 15,
    boxShadow: "0 2px 5px 0 rgba(var(--rgb-color-black), 0.1)",
    backgroundColor: "rgb(var(--rgb-color-white))",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    border: "1px solid transparent",
    textAlign: "center",
  },

  selectedCard: {
    borderColor: "rgb(var(--rgb-color-primair-basis))",
    fontWeight: "bold",
    color: "rgb(var(--rgb-color-primair-basis))",
  },
});
